<template>
    <svg
        :class="classes"
        :viewBox="icon.viewBox"
        :style="style"
        v-bind="$attrs"
        v-html="icon.data"
        v-if="icon"
    />
</template>

<script>
    import { getIcon } from '@/plugins/svg-icons.ts';

    export default {
        name: 'Icon',
        inheritAttrs: false,
        // FIXME(VUE3): Remove once compat mode is removed; real Vue 3 merges listeners into $attrs by default.
        compatConfig: { MODE: 3 },

        props: {
            height: {
                type: String,
                default: undefined,
            },
            name: {
                type: String,
                required: true,
            },
            scale: {
                type: String,
                default: undefined,
            },
            width: {
                type: String,
                default: undefined,
            },
            fill: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            icon() {
                return getIcon(this.name);
            },
            classes() {
                const classes = ['svg-icon'];
                if (this.fill || this.name.includes('bold/')) {
                    classes.push('svg-fill');
                }
                return classes;
            },
            style() {
                const style = {};
                if (this.width) {
                    style.width = this.width;
                }
                if (this.height) {
                    style.height = this.height;
                }
                if (this.scale) {
                    style.transform = `scale(${this.scale})`;
                    style.transformOrigin = 'center';
                }

                return Object.keys(style).length > 0 ? style : undefined;
            },
        },
    };
</script>
